<template>
  <div class="page">
    <div class="page-header">
      <Back @click="$router.back()" />
      <span> Validasi Pengambilan Toga </span>
    </div>

    <div class="body">
      <div style="text-align: center;padding-top: 100px;" v-if="loading">
        <Loading />
      </div>
      <div v-else>
        <p>Data siswa yang sudah mengambil Toga</p>
        <ul>
          <li v-for="(item, index) in data" :key="index">
            <div>
              <span>{{ item.no_daftar }}</span>
              <p>{{ item.nama_lengkap }}</p>
            </div>
            <div>
              <small>{{ item.waktu_ambil_formatted }}</small>
            </div>
          </li>
        </ul>

        <div class="mt" v-show="data.length <= 0">
          <p>Tidak ada data</p>
        </div>
      </div>

      <div class="btn-scan">
        <button @click="scan()" :disabled="loadingScan">
          {{ loadingScan ? "Validating data.." : "Scan QRCode TOGA" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../api";
import Back from "./../assets/Back.vue";
import Loading from "./../assets/Loading.vue";

export default {
  name: "app",
  data() {
    return {
      loading: false,
      loadingScan: false,
      data: [],
    };
  },
  components: {
    Back, Loading
  },
  methods: {
    scan() {
      setTimeout(() => {
        this.loadingScan = true;
        cordova.plugins.barcodeScanner.scan(
          (result) => {
            const token = result.text;
            api
              .postJson("/v1/wisuda/CheckinController/validasiToga", {
                token_toga: token,
              })
              .then((r) => {
                this.loadingScan = false;
                this.load();
                alert(r.message);
              })
              .catch((e) => {
                this.loadingScan = false;
                alert("Server error");
              });
          },
          (error) => {
            alert("Scanning failed: " + error);
          }
        );
      }, 150);
    },
    load() {
      this.loading = true;
      api
        .get("/v1/wisuda/CheckinController/listToga")
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
          alert("Gagal mengambil data");
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding-top: 60px;
  .body {
    padding-bottom: 80px;
    p {
      font-size: 14px;
    }
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;
        p {
          margin: 0;
          margin-top: 4px;
          font-weight: 600;
        }
        small {
          color: #777;
        }
      }
    }
  }

  .btn-scan {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #ccc;
    button {
      margin: 20px;
      width: calc(100% - 40px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ValidasiToga.vue